import React from 'react';
import Dict from 'dict-lib';
import ReactDom from 'react-dom';
import {getLexemeProperties} from '../../LexemePage';
import {savePhraseNotes} from './PhraseAction';
import {Grid, Row, InputGroup, FormControl} from 'react-bootstrap';
import './../../../../_css/lexeme.css';
import stylesSenses from './../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css';
import {LexemeUtilities} from "../LexemeHelper";
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";

export class PhraseNotes extends React.Component {

    constructor(props) {
        super(props);

        this.langDescr = typeof this.props.context.descrLanguage !== "undefined" ? this.props.context.descrLanguage : this.props.item.description[0].language;
        this.notes = this.props.additionalData.phraseItem.notes;

        this.state = {
            item: this.props.item,
            id: this.props.additionalData.phraseItem.id,
            text: typeof this.notes !== 'undefined' ? this._findNoteByLangText() : ''
        };

        this._handlePhraseNote = this._handlePhraseNote.bind(this);
        this._savePhraseNotes = this._savePhraseNotes.bind(this);
    }

    componentDidMount() {
        ReactDom.findDOMNode(this.translationNote).focus();
    }

    _findNoteByLangText() {
        var phraseItem = this.props.additionalData.phraseItem;
        var retNote = phraseItem.notes.notes_language_group.find((item) => {
            return item.language === this.langDescr;
        });

        return typeof retNote === 'undefined' || retNote === null ? '' : retNote.text;
    }

    _handlePhraseNote(evt) {
        var phraseItem = this.props.additionalData.phraseItem;

        if (typeof phraseItem.notes === 'undefined') {
            phraseItem.notes = {notes_language_group: []};
            phraseItem.notes.notes_language_group.push({language: this.langDescr, text: evt.target.value})
        } else {
            var text = this._findNoteByLangText();
            text = evt.target.value;
        }

        this.setState({text});
    }

    _savePhraseNotes() {
        this.setState({btDisabled: true});
        savePhraseNotes(this.state.item.ids, this.state.text, this.state.id).then(result => {
        });
    }

    render() {

        return <Grid className={stylesSenses['sense-notes-container']} fluid>
            <InputGroup className={stylesSenses['sense-notes']}>
                <FormControl type="text" placeholder={Dict.t('NOTES') + "..."}
                             ref={(input) => {
                                 this.translationNote = input;
                             }}
                             value={this.state.text}
                             onChange={(evt) => this._handlePhraseNote(evt)}
                             onKeyUp={(evt) => {
                                 LexemeUtilities.handleKeyUp(evt, () => {
                                     this._savePhraseNotes();
                                 })
                             }}
                />
            </InputGroup>
            <Row className={stylesSenses['sense-notes__row-bt']}>
                <SCSubmitButton onClick={() => this._savePhraseNotes()} text={Dict.t('SAVE')}/>
            </Row>
        </Grid>;
    }


}
